export enum FormMatrixFormName {
  CVS_CAREMARK_NON_MEDICARE = "CVS Caremark Non-Medicare Formulary Exception / Prior Authorization Request Form",
  EXPRESS_SCRIPTS_GENERAL = "Express Scripts General Request Form",
  CAREMARK_MEDICARE_COVERAGE = "Caremark Medicare Coverage Determination Request Form",
  NYRX_MEDICAID = "NYRx Medicaid Pharmacy Program Prescription Prior Authorization Request Form",
  OPTUMRX_COMMERCIAL = "OptumRx Commercial Prior Authorization Request Form",
  WELLCARE_MEDICARE = "WellCare Medicare Drug Coverage Request Form",
  FIDELIS_CARE_COMMERCIAL = "Fidelis Care Commercial and Exchange Prior Authorization Form",
  OPTUMRX_MEDICARE_PART_D = "OptumRx Medicare Part D General Prior Authorization Request Form",
  ANTHEM_BCBS_NY_COMMERCIAL = "Anthem Blue Cross Blue Shield of New York Commercial Prior Authorization Form",
  CIGNA_MEDICARE_ADVANTAGE = "Cigna Medicare Advantage Prescription Coverage Determination Form",
  EMBLEM_HEALTH_GENERAL = "Emblem Health General Request Form",
  HUMANA_MEDICARE = "Humana Medicare Prescription Coverage Determination Form",
  AETNA_COMMERCIAL_GENERAL = "Aetna Commercial General Form",
  EMBLEMHEALTH_COMMERCIAL = "EmblemHealth Commercial Prior Authorization Form",
}

export const FORM_MATRIX_FORM_NAME_OPTIONS = Object.values(
  FormMatrixFormName,
).map((name) => ({
  value: name,
  label: name,
}));
